import { FaBookOpen, FaChessKnight, FaGraduationCap } from "react-icons/fa";

// Enable this when the Guides section is ready to become the primary learning
// navigation again. When disabled, navigation links directly to the existing
// interactive opening lessons.
export const ENABLE_GUIDES_NAVIGATION: boolean = false;

export const learningDestinations = [
  {
    href: "/guides",
    menuLabel: "Chess guides",
    icon: FaBookOpen,
  },
  {
    href: "/openings",
    menuLabel: "Openings",
    icon: FaChessKnight,
  },
  {
    href: "/learn/openings",
    menuLabel: "Interactive lessons",
    icon: FaGraduationCap,
  },
] as const;
